import { Component, OnInit, input, output, ChangeDetectionStrategy } from '@angular/core';
import { AppSettings } from '../../app.settings';
import { Property } from '../../models/property';
import { SoldProperty } from '../../models/soldProperty';

@Component({ standalone: false,
  selector: 'app-property-item',
  templateUrl: './property-item.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./property-item.component.scss'] 
})
export class PropertyItemComponent implements OnInit {
  readonly property = input<Property|SoldProperty>();
  readonly viewType = input<string>("grid");
  readonly fullWidthPage = input<boolean>(true);
  readonly propertyItemClicked = output<Property|SoldProperty>();

  public column:number = 4;

  private colorList:{statusName:string,colorCode:string}[]=[{statusName:'Coming Soon',colorCode:'#558B2F'},
    {statusName:'Bidding Starts',colorCode:'#01579B'},
    {statusName:'Buy Now',colorCode:'#1E88E5'},
    {statusName:'Auction',colorCode:'#009688'},
    {statusName:'Sale',colorCode:'#1E88E5'},
    {statusName:'Call For Offer',colorCode:'#1E88E5'},
    {statusName:'Featured',colorCode:'#FFA000'},
    {statusName:'Ended',colorCode:'#000'},
    {statusName:'No Premium',colorCode:'#1D8BF1'},
    {statusName:'Hot',colorCode:'#FF0000'},
    {statusName:'Postponed',colorCode:'#1E88E5'},
  ]

  constructor(private appSettings:AppSettings) {
  }

  ngOnInit() { }

  public onClick(){
    this.propertyItemClicked.emit(this.property()!);
  }

  get settings(){
    return this.appSettings.settings;  
  }

  isProperty(p: Property | SoldProperty | undefined): p is Property {
    return !!p && 'auction' in p;
  }

  get isAuction(){
    const property = this.property();
    return property instanceof Property && property.auction?.auctionType === 1;
  }

  get isMakeOfferBuyNow(){
    const property = this.property();
    return property instanceof Property && property.auction?.auctionType === 2;
  }

  get isRegularSale(){
    const property = this.property();
    return property instanceof Property && property.auction?.auctionType === 3;
  }

  get isCallForOffer(){
    const property = this.property();
    return property instanceof Property && property.auction?.auctionType === 4;
  }

  public getStatusBgColor(status:string){
    let color = this.colorList.find(c=>status.startsWith(c.statusName))?.colorCode
    if(!color) color="#01579B";
    return color;
  }
}
